<template>
  <!--货主 -->
  <el-form-item label="项目">
    <el-select
      v-model="project_name"
      :disabled="modify"
      filterable
      remote
      placeholder="请选择"
      @change="unitProject"
      clearable
      :remote-method="remoteMethod_project"
    >
      <el-option
        v-for="(item, index) in historyProject"
        :key="index"
        :label="item.project_name"
        :value="item.pid"
      ></el-option>
    </el-select>
    <!-- <i class="iconfont icon-icon12 unit"></i> -->
  </el-form-item>
</template>

<script>
import { isSuccess } from "@/assets/js/utils";
export default {
  data() {
    return {
      historyProject: [],
      project_pid: this.projectPid,
      project_name: this.projectName,
      modify: this.projectModify,
      billing: [],
    };
  },
  //   props: ['infoPid', 'infoCode', 'infoName', 'ifModify'],
  props: {
    projectPid: {
      required: false,
    },
    projectName: {
      required: false,
    },
    projectModify: {
      required: false,
    },
  },
  created() {},
  watch: {
    projectPid: function (newVal, oldVal) {
      this.project_pid = newVal;
    },
    projectName: function (newVal, oldVal) {
      this.project_name = newVal;
    },
    projectModify: function (newVal, oldVal) {
      this.modify = newVal;
    },
  },
  methods: {
    remoteMethod_project(query) {
      let json = {
        project_name: query,
      };
      if (query != "") {
        api("project.batch.query", json).then((res) => {
          let data;
          if ((data = isSuccess(res))) {
            this.historyProject = data;
          }
        });
      }
    },
    unitProject(val) {
      if (val) {
        this.project_name = this.historyProject.find((item) => {
          return item.pid === val;
        }).project_name;
        this.billing = this.historyProject.find((item) => {
          return item.pid === val;
        }).billing_name_response_list;
        this.project_pid = val;
      } else {
        this.project_name = "";
        val = "";
      }
      this.$emit("getProject", val, this.project_name, this.billing);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/unitcode/project-name.vue